module.exports = __webpack_public_path__ + "static/img/img2.c2e4071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202210/img2.png
// module id = HOnd
// module chunks = 0